import type { PaneData } from '../../shared/contracts';
import { formatMetric } from '../../shared/format';
import { PaneFrame } from './PaneFrame';
import { RadialRing } from './charts';

export function ProgressCard({ pane, eyebrow, onDrill }: { pane: PaneData; eyebrow?: string; onDrill?: (bucket?: string) => void }) {
  const progress = pane.progress;
  if (!progress) return null;
  const pct = progress.target > 0 ? Math.min(100, Math.round((progress.current / progress.target) * 100)) : 0;
  const remaining = Math.max(0, progress.target - progress.current);
  // Drillable when the pane exposes what the progress consists of (breakdown/details).
  const drillable = Boolean(pane.breakdown?.length || pane.details?.length || pane.table?.rows.length);
  const onOpen = drillable && onDrill ? () => onDrill() : undefined;
  return (
    <PaneFrame title={pane.title} source={pane.source} eyebrow={eyebrow} periodLabel={pane.periodLabel} onOpen={onOpen}>
      <div className="flex flex-col items-center pt-2 text-center">
        <RadialRing value={progress.current} max={progress.target} centerLabel={`${pct}%`} sublabel="nået" className="h-36 w-36" />
        <div className="mt-4 text-xs text-brand-dark/50">Rest til budget</div>
        <div className="font-heading text-3xl font-bold tracking-tight text-brand-primary">
          {formatMetric(remaining, progress.format, progress.unit)}
        </div>
        <div className="mt-1 text-[11px] text-brand-dark/50">Mål {formatMetric(progress.target, progress.format, progress.unit)}</div>
        {pane.note && <p className="mt-2 text-xs text-brand-dark/50">{pane.note}</p>}
      </div>
    </PaneFrame>
  );
}
